// this file is webbee_common_geograohic in assests folder
const collectionMap = new Map();
let shopifyQty1 = varintsShopifyStore;

shopifyQty1.split(",").map(res => {
    let sp = res.split("/");
    collectionMap.set(sp[0], sp[1]);
});

let countryCodeTemp = "";
if (typeof countryCode !== 'undefined') {
    countryCodeTemp = countryCode;
}

if (!window.idquantity) {
    window.idquantity = new Map();
}
var idquantity = window.idquantity;

/**
     * Global JSONP callback expected by the backend.
     * The server always responds with: callback({ ... })
     *
     * We'll forward the data to a handler set per webbeeGeolocation() invocation.
     */
window.callback = function (response) {
    if (typeof window._webbeeJsonpHandler === 'function') {
        window._webbeeJsonpHandler(response);
    }
};

function webbeeGeolocation(variantSku, domainName) {
    // --- Prepare SKU array ------------------------------------------------
    var MAX_BATCH_LEN = 40; // number of SKUs per batch
    var variantArr = [];

    if (Array.isArray(variantSku)) {
        variantArr = variantSku;
    } else if (typeof variantSku === 'string') {
        variantArr = variantSku
            .split(',')
            .map(function (x) { return x.trim(); })
            .filter(Boolean);
    }

    // Fallback: if no commas and non-empty, treat as single SKU
    if (variantArr.length === 0 && variantSku) {
        variantArr = [String(variantSku)];
    }

    var numBatches = Math.ceil(variantArr.length / MAX_BATCH_LEN);
    if (numBatches === 0) {
        return;
    }

    var batchesCompleted = 0;

    // --- UI finalization --------------------------------------------------
    function finishUI() {
        // Run list page UI update once when all batches are done
        try {
            if (window.page === 'listpage' && typeof window.soldOutGeoLocation === 'function') {
                console.log(idquantity);
                window.soldOutGeoLocation();
            }
        } catch (e) {
            // swallow
        }

        // Enable/disable button depending on current SKU qty
        try {
            var qty = idquantity.get(window.webbeeSku);
            if (qty === 0 || qty === null || qty === undefined) {
                $(window.btn).attr('disabled', true);
                if (typeof window.txt !== 'undefined' && window.txt) {
                    $(window.btn).html(window.txt);
                }
            } else {
                $(window.btn).attr('disabled', false);
            }
        } catch (e2) {
            // swallow
        }
    }

    // Handler for ALL JSONP responses for this invocation
    window._webbeeJsonpHandler = function (callbackData) {
        if (callbackData && callbackData.status === 'success' && Array.isArray(callbackData.data)) {
            var responseFromServer = callbackData.data;

            for (var i = 0; i < responseFromServer.length; i++) {
                var object = responseFromServer[i];

                // Debug/check for a specific SKU if needed
                if (object.variantSKU === '112033') {
                    console.log(object.quantity);
                }

                idquantity.set(object.variantSKU, object.quantity);
            }
        } else if (callbackData &&
                   callbackData.status === 'fail' &&
                   callbackData.geoLocationZeroInventory === 'Yes') {

            // Zero inventory phase
            idquantity.set('zero inventory', true);
        }

        batchesCompleted++;
        if (batchesCompleted === numBatches) {
            finishUI();
            // optional: clear handler after we're done
            window._webbeeJsonpHandler = null;
        }
    };

    // --- Low-level JSONP loader using <script> ---------------------------
    function fetchVariantBatch(skuBatchArr) {
        var skuBatchString = skuBatchArr.join(',');

        var payload = {
            variantSKUList: skuBatchString,
            domainName: domainName,
            countryCode: countryCodeTemp
        };
        console.log(payload);

        // Backend currently expects the encoded JSON object appended after &,
        // producing URLs like:
        //   ?callback=callback&%7B"variantSKUList":"85032,76012",...%7D
        var encodedValues = encodeURIComponent(JSON.stringify(payload));

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;

        script.src =
            'https://hooks.webbeeglobal.com/ShopifyAmazonFBAConnecotr/shopify/location-qty' +
            '?callback=callback&' +
            encodedValues;

        script.onerror = function () {
            // Count this batch as failed but completed
            batchesCompleted++;
            try {
                $(window.btn).attr('disabled', false);
            } catch (e) {}

            if (batchesCompleted === numBatches) {
                finishUI();
                window._webbeeJsonpHandler = null;
            }
        };

        document.head.appendChild(script);
    }

    // --- Fire all batches in parallel (safe with stable callback) --------
    for (var i = 0; i < numBatches; i++) {
        var batchSlice = variantArr.slice(i * MAX_BATCH_LEN, (i + 1) * MAX_BATCH_LEN);
        fetchVariantBatch(batchSlice);
    }
}

webbeeGeolocation(variantSku, domainName);

$(btn).on('click', function(evt) {
    let skus = $("#webbeesku").val();
    skus = webbeeSku;

    let qty = idquantity.get(skus);
    let cartqty = collectionMap.get(skus);

    if (cartqty === undefined) {
        cartqty = 0;
    }

    if (Number(cartqty) + 1 > Number(qty)) {
        $(btn).attr("disabled", "true");
        evt.preventDefault();
        $("#msg").html("Available quantity " + Number(qty));
    } else {
        $("#msg").html("");
    }

    if (qty === undefined || qty === 0) {
        $(btn).attr("disabled", "true");
        $("#msg").html("Available quantity 0");
        evt.preventDefault();
    }
});